import React, { useEffect, useState } from 'react';
import { Modal, Button, Input, FormHelperText } from '@mui/material';
import { styled } from '@mui/system';
import DeleteIcon from '@mui/icons-material/Delete';
import "./index.css"
// Styled container for modal content
const ModalContainer = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: 24,
  width: '500px',
  textAlign: 'center',
});

const ModalTitle = styled('h2')({
  marginBottom: '15px',
  fontSize: '18px',
});

const ModalActions = styled('div')({
  marginTop: '15px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: "center"
});

const index = ({ open, onClose, onDelete, deleteLoading }) => {
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState(false);

  // Resets the confirm-text input whenever the modal closes, whichever way
  // that happens - Cancel, or the parent closing it after a successful
  // delete (via onDelete's onSuccess). Does NOT fire on a failed delete,
  // since the parent then leaves `open` true so the user can retry.
  useEffect(() => {
    if (!open) {
      setInputValue('');
      setError(false);
    }
  }, [open]);

  const handleDelete = async () => {
    if (inputValue.toLowerCase() === 'delete') {
      // Closing is the parent's call, not ours - it only sets open=false
      // once onDelete's mutation actually succeeds.
      await onDelete();
    } else {
      setError(true);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalContainer>
        <ModalTitle>Confirm Deletion</ModalTitle>
        <p>Type delete to confirm deletion</p>  {/* Escaped quotes */}
        <input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Type delete to confirm"
          fullWidth
          style={{ width: "100%", padding: "10px" }}
        />
        {error && <FormHelperText error>Delete is required</FormHelperText>}
        <ModalActions >
          <Button variant="contained" style={{ color: "white" }} color="secondary" onClick={onClose}>Cancel</Button>
          <Button variant="contained" style={{ background: "red", color: "white" }} endIcon={<DeleteIcon />} onClick={handleDelete} disabled={deleteLoading}>
            {deleteLoading ? (
              <span className="loader-spinner"></span>
            ) : (
              "Delete"
            )}
          </Button>
        </ModalActions>
      </ModalContainer>
    </Modal>
  );
};

export default index;
